import React from 'react';
import './axiosConfig'; // JWT interceptor — must be imported first
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Applications from './pages/Applications';
import Actions from './pages/Actions';
import ApplicationDetail from './pages/ApplicationDetail';
import Commodities from './pages/Commodities';
import Inspectors from './pages/Inspectors';
import Templates from './pages/Templates';
import Users from './pages/Users';
import AuditLog from './pages/AuditLog';
import Settings from './pages/Settings';

import './App.css';
import './pages/PageStyles.css';

function currentUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
}

function PrivateRoute({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" replace />;
}

/** Super Admin only — users, commodities, templates and global settings. */
function SuperAdminRoute({ children }) {
  return currentUser().role === 'Super Admin' ? children : <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/actions" element={<Actions />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/applications/:id" element={<ApplicationDetail />} />
          <Route path="/commodities" element={<Commodities />} />
          <Route path="/inspectors" element={<Inspectors />} />
          <Route path="/templates" element={<SuperAdminRoute><Templates /></SuperAdminRoute>} />
          <Route path="/users" element={<SuperAdminRoute><Users /></SuperAdminRoute>} />
          <Route path="/audit" element={<AuditLog />} />
          <Route path="/settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
